import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/www/OL/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "bonjour-et-bienvenue-"
    }}>{`Bonjour et bienvenue !`}</h2>
    <p>{`Voici une collection d'outils SIG  utilisant les  libairies OpenSources (OpenLayer, leaflet)`}</p>
    <p>{`En particulier une démonstration de l'outil:`}</p>
    <ul>
      <li parentName="ul">{`géolocalisation : `}<a parentName="li" {...{
          "href": "./docs-sig-carte-wms"
        }}>{`DEMO`}</a></li>
      <li parentName="ul">{`angle : `}<a parentName="li" {...{
          "href": "./tools/angle/index.html"
        }}>{`OUTILS ANGLE`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      